export default __webpack_public_path__ + "static/media/icon-arrow_right-disabled.9660ae14.svg";